import type { FC, ReactElement } from 'react';

import classNames from 'classnames';

import type { AriaProps } from '@iconik-io/shared-lib/src/react/a11y/aria';
import { Icon, type IconName } from '@iconik-io/uad';

import Button from '../button/button';
import { VARIANTS } from '../label/label';

import mixins from '../../styles/core/mixins.module.css';
import styles from './dropdown_button.module.css';

type Props = {
  className?: string;
  disabled?: boolean;
  iconName?: IconName;
  title?: string | ReactElement;
  aria?: AriaProps;
  // UI tests identifier
  uiKey?: string;
};

const DropDownButton: FC<Props> = (props) => (
  <Button
    className={classNames(styles.button, props.className)}
    variant={VARIANTS.WHITE}
    disabled={props.disabled}
    iconName={props.iconName}
    noBorder
    wideBasis={false}
    uiKey={props.uiKey}
    aria={props.aria}
  >
    {props.title}
    <Icon
      name="chevron_small_isolated_s"
      className={classNames(styles.chevron_icon, mixins.text_align_icon)}
      size="xs"
    />
  </Button>
);

export default DropDownButton;
